import React from 'react';
import AddressForm from './components/AddressForm';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <h1>Hangout Halfway</h1>
      </header>
      <main>
        <AddressForm />
      </main>
    </div>
  );
}

export default App;
